import { z } from 'zod'

import { MinimumFile } from '@/modules/shared/schemas/MinimumFile'

export const BelongItemStatusEnum = z.enum([
  'READY_TO_USE',
  'PENDING',
  'LOST',
  'DAMAGED'
])

export const BelongItemList = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    status: BelongItemStatusEnum,
    imageFile: MinimumFile
  })
)

export type BelongItemStatusEnum = z.infer<typeof BelongItemStatusEnum>
export type BelongItemList = z.infer<typeof BelongItemList>
